import { UpdateDiscountGroupComponent } from './update-discount-group/update-discount-group.component'
import { CreateDiscountGroupComponent } from './create-discount-group/create-discount-group.component'
import { DiscountGroupsComponent } from './discount-groups.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const discountGroupsRoutes: Routes = [
  {
    path: 'admin/discount-groups',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'DISCOUNT_GROUPS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: DiscountGroupsComponent,
        data: {
          permissions: {
            only: 'DISCOUNT_GROUPS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateDiscountGroupComponent,
        data: {
          permissions: {
            only: 'DISCOUNT_GROUPS',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateDiscountGroupComponent,
        data: {
          permissions: {
            only: 'DISCOUNT_GROUPS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
